
/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>渠道注册</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">

      <el-form-item prop="beginTime" label="数据时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                          v-model="formInline.beginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期" v-model="formInline.endTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
      </el-form-item>
      <el-form-item>
      </el-form-item>

    </el-form>

    <!--列表-->
    <el-table id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row
              v-loading="loading" @select-all="selectall" element-loading-text="拼命加载中"
              style=" font-size: 20px;">

      <el-table-column align="center" prop="typeDesc" :label="  '客户来源'+ `(总客户来源数 :${listNum.allSize})`"
                       width="300">
      </el-table-column>
      <el-table-column align="center" prop="allRegisterCount" :label="'总注册'+`(总注册数: ${listNum.allCount})`"
                       width="300">
      </el-table-column>
      <el-table-column align="center" prop="manRegisterCount" :label="'男注册'+`(男总注册数: ${listNum.allManCount})`"
                       width="300">
      </el-table-column>
      <el-table-column align="center" prop="womanRegisterCount"
                       :label="'女注册'+`(女总注册数: ${listNum.allWomanCount})`" width="300">
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination> -->
    <div
      style="font-size: 30px; color: #56c1ff; height: 60px;  margin-top: 30px; text-align: left;">用户列表-男总数据分析总计:{{ listNum.allManCount }}人
    </div>
    <div class="adew">
      <div class="adewchild" id="manage"></div>
      <div class="adewchild" id="manMarital"></div>
      <div class="adewchild" id="manMonthly"></div>
      <div class="adewchild" id="manDegree"></div>
      <div class="adewchild" id="manDatasource"></div>
    </div>
    <div
      style="font-size: 30px; color: #cb2a7b; height: 60px;  margin-top: 30px; text-align: left;">用户列表-女总数据分析总计:{{ listNum.allWomanCount }}人
    </div>
    <div class="adew">
      <div class="adewchild" id="womanage"></div>
      <div class="adewchild" id="womanMarital"></div>
      <div class="adewchild" id="womanMonthly"></div>
      <div class="adewchild" id="womanDegree"></div>
      <div class="adewchild" id="womanDatasource"></div>
    </div>
    <div
      style="font-size: 30px; color: #783DF9; height: 60px;  margin-top: 30px; text-align: left;">用户列表-男女总数据分析总计:{{ listNum.allCount }}人
    </div>
    <div class="adew">
      <div class="adewchild" id="allage"></div>
      <div class="adewchild" id="allCount"></div>
      <div class="adewchild" id="allMarital"></div>
      <div class="adewchild" id="allMonthly"></div>
      <div class="adewchild" id="allDegree"></div>
      <div class="adewchild" id="allDatasource"></div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import {roleList,roleAdd,roleDelete,roleEdit,channelRegister} from '../../api/userMG'
import Axios from 'axios'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogVisible: false,
      value: "",
      options123: [],
      listNum:[],
      ssoServer:"",
      indexsds:12,
      formLabelWidth: '120px',
      dialogFormVisible:false,
      options1234123: [],
      ifindex:"",
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      roleId:"",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      SelectList:'',
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        name: '',
      },
      allAgeBarChart:{},
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        endTime:"",
        beginTime:"",
        current: 1,
        size: 20,
      },
      ids:"",
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.value=(new Date()).getTime();
    this.formInline.beginTime =this.timeDefault
     this.formInline.endTime =this.timeDefaults
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId
  },
  mounted() {
    this.formLIst()
    this.allage()
    // this.drawChart()
  },
  computed: {
    timeDefault() {
      let date = new Date();
      let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
      let day = (date.getDate()) > 9 ? (date.getDate()) : '0' + (date.getDate());
      return date.getFullYear() + "-" + month + "-" + day + " " + '00:00:00';
    },
    timeDefaults() {
      let date = new Date();
      let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
      let day = (date.getDate()) > 9 ? (date.getDate()) : '0' + (date.getDate());
      return date.getFullYear() + "-" + month + "-" + day + " " + '23:59:59';
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    drawChart(res,list) {
      let myChart = this.$echarts.init(document.getElementById("manage"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#56c1ff'],
        title: {
          text: "男年龄段",
          textStyle:{
            color:'#56c1ff'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#56c1ff',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },

    allage(res,list) {
      let myChart = this.$echarts.init(document.getElementById("allage"));
      // 指定图表的配置项和数据
     let option = {
  title: {
    text: '男女报名人数总占比',
    subtext: '人数',
    left: 'center'
  },

  toolbox: {
    show: true,
    feature: {
      mark: { show: true },
      dataView: { show: true, readOnly: false },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  tooltip: {
    trigger: 'item',


  },
  legend: {
    orient: 'vertical',
    left: 'left'
  },
  series: [
    {
      name: 'Access From',
      type: 'pie',
      radius: '50%',


      data: [
        { value: 1048, name: '男' },
        { value: 735, name: '女' },

      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
};
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },

    allCount(res,list) {
      let myChart = this.$echarts.init(document.getElementById("allCount"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#783DF9'],
        title: {
          text: "男女总年龄段",
          textStyle:{
            color:'#783DF9'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#783DF9',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    womanage(res,list) {
      let myChart = this.$echarts.init(document.getElementById("womanage"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#cb2a7b'],
        title: {
          text: "女年龄段",
          textStyle:{
            color:'#cb2a7b'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#cb2a7b',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    drawChartx(res,list) {
      let myChart = this.$echarts.init(document.getElementById("manDegree"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#56c1ff'],
        title: {
          text: "男学历",
          textStyle:{
            color:'#56c1ff'
          }

        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#56c1ff',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    allDegree(res,list) {
      let myChart = this.$echarts.init(document.getElementById("allDegree"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#783DF9'],
        title: {
          text: "男女总学历",
          textStyle:{
            color:'#783DF9'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#783DF9',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    womanDegree(res,list) {
      let myChart = this.$echarts.init(document.getElementById("womanDegree"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#cb2a7b'],
        title: {
          text: "女学历",
          textStyle:{
            color:'#cb2a7b'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#cb2a7b',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },



    manMonthly(res,list) {
      let myChart = this.$echarts.init(document.getElementById("manMonthly"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#56c1ff'],
        title: {
          text: "男月收入",
          textStyle:{
            color:'#56c1ff'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#56c1ff',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    allMonthly(res,list) {
      let myChart = this.$echarts.init(document.getElementById("allMonthly"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#783DF9'],
        title: {
          text: "男女总月收入",
          textStyle:{
            color:'#783DF9'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#783DF9',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    womanMonthly(res,list) {
      let myChart = this.$echarts.init(document.getElementById("womanMonthly"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#cb2a7b'],
        title: {
          text: "女月收入",
          textStyle:{
            color:'#cb2a7b'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#cb2a7b',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    manDatasource(res,list,lis) {
      let adder = '男来源数据:'+lis
      let myChart = this.$echarts.init(document.getElementById("manDatasource"));
      // 指定图表的配置项和数据
      let option = {
        grid: { // 控制图的大小，调整下面这些值就可以，
		x: 100,//控制x轴文字与底部的距离
         y2: 100 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
		},
        color: ['#56c1ff'],
        title: {
          text: adder,
          textStyle:{
            color:'#56c1ff'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: [{
          data: res,
			type: 'category',
			//data: ['2015-2016', '2016-2017', '2017-2018', '2018-2019']
			axisLabel: {
						interval: 0,    //强制文字产生间隔
					    rotate: 45,     //文字逆时针旋转45°
						textStyle: {    //文字样式
						            color: "black",
						            fontSize: 16,
						            fontFamily: 'Microsoft YaHei'
						            }
					   }

		  }],


        // xAxis: {

        //   rotate: 45,
        // },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            rotate: 45,
            interval:0,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
                  interval:0,

									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#56c1ff',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    allDatasource(res,list,lis) {
      let adder = '男女总来源:'+lis
      let myChart = this.$echarts.init(document.getElementById("allDatasource"));
      // 指定图表的配置项和数据
      let option = {
        grid: { // 控制图的大小，调整下面这些值就可以，
		x: 50,//控制x轴文字与底部的距离
         y2: 100 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
		},
        color: ['#783DF9'],
        title: {
          text: adder,
          textStyle:{
            color:'#783DF9'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: [{
          data: res,
			type: 'category',
			//data: ['2015-2016', '2016-2017', '2017-2018', '2018-2019']
			axisLabel: {
						interval: 0,    //强制文字产生间隔
					    rotate: 45,     //文字逆时针旋转45°
						textStyle: {    //文字样式
						            color: "black",
						            fontSize: 16,
						            fontFamily: 'Microsoft YaHei'
						            }
					   }

		  }],
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
                  interval: 0,

									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#783DF9',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    womanDatasource(res,list,lis) {
      let adder = '女来源数据:'+lis
      let myChart = this.$echarts.init(document.getElementById("womanDatasource"));
      // 指定图表的配置项和数据
      let option = {
        grid: { // 控制图的大小，调整下面这些值就可以，
		x: 50,//控制x轴文字与底部的距离
         y2: 100 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
		},
        color: ['#cb2a7b'],
        title: {
          text: adder,
          textStyle:{
            color:'#cb2a7b'
          }
        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: [{
          data: res,
			type: 'category',
			//data: ['2015-2016', '2016-2017', '2017-2018', '2018-2019']
			axisLabel: {
						interval: 0,    //强制文字产生间隔
					    rotate: 45,     //文字逆时针旋转45°
						textStyle: {    //文字样式
						            color: "black",
						            fontSize: 16,
						            fontFamily: 'Microsoft YaHei'
						            }
					   }

		  }],
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
                  interval: 0,

									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#cb2a7b',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    manMarital(res,list) {
      let myChart = this.$echarts.init(document.getElementById("manMarital"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#56c1ff'],
        title: {
          text: "男婚况",
          textStyle:{
            color:'#56c1ff'
          }

        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#56c1ff',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    allMarital(res,list) {
      let myChart = this.$echarts.init(document.getElementById("allMarital"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#783DF9'],
        title: {
          text: "男女总婚况",
          textStyle:{
color: "#783DF9"
          },


        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#783DF9',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },
    womanMarital(res,list) {
      let myChart = this.$echarts.init(document.getElementById("womanMarital"));
      // 指定图表的配置项和数据
      let option = {
        color: ['#cb2a7b'],
        title: {
          text: "女婚况",
          textStyle:{
color: "#cb2a7b"
          },


        },
        tooltip: {
          show: true,
          formatter: '{a}{b} : {c}人'
        },
        legend: {
          data: ["人数"],
        },
        xAxis: {
          data: res,
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: "",
            type: "bar",
            data:list,
            itemStyle: {
							normal: {
								label: {
                  formatter:function(data){
          return data.value+'人'
        },
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#cb2a7b',
										fontSize: 16
									}
								}
							}
						},

          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应

    },

    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },



    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据


    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },
    formLIst() {
        channelRegister(this.formInline).then(res=>{
            if(res.code==0){
              this.listNum =res.data
            this.listData = res.data.list
        this.pageparm.total = res.data.total
        this.drawChart(res.data.manAgeBarChart.x,res.data.manAgeBarChart.y)
        this.drawChartx(res.data.manEducationBarChart.x,res.data.manEducationBarChart.y)
        this.manMonthly(res.data.manMonthlyIncomeBarChart.x,res.data.manMonthlyIncomeBarChart.y)
        this.manMarital(res.data.manMaritalStatusBarChart.x,res.data.manMaritalStatusBarChart.y)
        this.manDatasource(res.data.manSourceBarChart.x,res.data.manSourceBarChart.y,res.data.allManCount)
        this.womanage(res.data.womanAgeBarChart.x,res.data.womanAgeBarChart.y)
        this.womanMarital(res.data.womanMaritalStatusBarChart.x,res.data.womanMaritalStatusBarChart.y)
        this.womanMonthly(res.data.womanMonthlyIncomeBarChart.x,res.data.womanMonthlyIncomeBarChart.y)
        this.womanDegree(res.data.womanEducationBarChart.x,res.data.womanEducationBarChart.y)
        this.womanDatasource(res.data.womanSourceBarChart.x,res.data.womanSourceBarChart.y,res.data.allWomanCount)


        this.allCount(res.data.allAgeBarChart.x,res.data.allAgeBarChart.y)
        this.allMarital(res.data.allMaritalStatusBarChart.x,res.data.allMaritalStatusBarChart.y)
        this.allMonthly(res.data.allMonthlyIncomeBarChart.x,res.data.allMonthlyIncomeBarChart.y)
        this.allDegree(res.data.allEducationBarChart.x,res.data.allEducationBarChart.y)
        this.allDatasource(res.data.allSourceBarChart.x,res.data.allSourceBarChart.y,res.data.allCount)















        // console.log(this.allAgeBarChart.x);
            }
        })
    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {

        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });


        channelRegister(this.formInline).then(res=>{
            if(res.code==0){
              this.listNum =res.data
            this.listData = res.data.list
        this.pageparm.total = res.data.total
        this.drawChart(res.data.manAgeBarChart.x,res.data.manAgeBarChart.y)
        this.drawChartx(res.data.manEducationBarChart.x,res.data.manEducationBarChart.y)
        this.manMonthly(res.data.manMonthlyIncomeBarChart.x,res.data.manMonthlyIncomeBarChart.y)
        this.manMarital(res.data.manMaritalStatusBarChart.x,res.data.manMaritalStatusBarChart.y)
        this.manDatasource(res.data.manSourceBarChart.x,res.data.manSourceBarChart.y,res.data.allManCount)
        this.womanage(res.data.womanAgeBarChart.x,res.data.womanAgeBarChart.y)
        this.womanMarital(res.data.womanMaritalStatusBarChart.x,res.data.womanMaritalStatusBarChart.y)
        this.womanMonthly(res.data.womanMonthlyIncomeBarChart.x,res.data.womanMonthlyIncomeBarChart.y)
        this.womanDegree(res.data.womanEducationBarChart.x,res.data.womanEducationBarChart.y)
        this.womanDatasource(res.data.womanSourceBarChart.x,res.data.womanSourceBarChart.y,res.data.allWomanCount)


        this.allCount(res.data.allAgeBarChart.x,res.data.allAgeBarChart.y)
        this.allMarital(res.data.allMaritalStatusBarChart.x,res.data.allMaritalStatusBarChart.y)
        this.allMonthly(res.data.allMonthlyIncomeBarChart.x,res.data.allMonthlyIncomeBarChart.y)
        this.allDegree(res.data.allEducationBarChart.x,res.data.allEducationBarChart.y)
        this.allDatasource(res.data.allSourceBarChart.x,res.data.allSourceBarChart.y,res.data.allCount)
        loading.close();
        // console.log(this.allAgeBarChart.x);
            }
        })
        // setTimeout(() => {

        // }, 2000);

      // this.formInline.current = 1
      // this.value=(new Date()).getTime();

      // this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.$router.push({
    path:"/Eventmanagement/Eventdetails",
    query:{ //query是个配置项
        id:row.id
    }
})


    },
    // 编辑、增加页面保存方法


    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
.adew{
  width: 100%;
  /* height: 700px; */
  /* background-color: saddlebrown; */
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;

}
.adewchild{
  flex: 48%;
height: 350px;



}
</style>





// WEBPACK FOOTER //
// src/views/goods/registRation.vue